'use client';

import React, { Dispatch, SetStateAction } from 'react';

export const HeaderVisibilityContext = React.createContext<{
  headerVisible?: boolean;
  setHeaderVisible: Dispatch<SetStateAction<boolean>>;
}>({ headerVisible: true, setHeaderVisible: () => {} });
